// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__2zkDk","loadingShrink":"PageLoading_loadingShrink__3uCaj"};